import { config, IJsonRpcResponse } from "./api";

export interface ILog {
    id: number,
    customerID: number,
    channel: string,
    level: number,
    description: string,
    payload: string,
    createTimestamp: string,
}

interface IGetLogsResponse extends IJsonRpcResponse {
    result: ILog[],
}

export const getLogs = async (authToken: string, offset?: number) => {
    const res = await fetch(`${config.url}/getLogs`, {
        body: JSON.stringify({ offset }),
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + authToken,
            'Content-Type': 'application/json',
        },
        method: 'POST',
    });

    const body: IGetLogsResponse = await res.json() as IGetLogsResponse;
    for(const log of body.result) {
        log.payload = JSON.stringify(log.payload, null, 4);
    }
    return body.result;
}
